import Vue from 'vue'
import Router from 'vue-router'
import { store } from '@/store'

// Parent Components
import Login from '@/components/Login'
import Main from '@/components/layout/Main'

// Children of Main Component
import Session from '@/components/Session'
import StartScreen from '@/components/StartScreen'

import Wizard from '@/components/Wizard'
import WizardSummary from '@/components/WizardSummary'

import Compare from '@/components/Compare'
import FinalSelection from '@/components/FinalSelection'

import Lookup from '@/components/Lookup'
import PlatformViewer from '@/components/PlatformViewer'

// other...
import AuthGuard from './auth-guard'
import firebase from 'firebase'

Vue.use(Router)

const router = new Router({
  base: '/',
  mode: 'history', // requires HTML5 History and server config (pretty urls)
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: AuthGuard,
      meta: { isLogin: true }
    },
    {
      path: '/',
      // name: 'Main',
      redirect: '/home',
      component: Main,
      beforeEnter: AuthGuard,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'home',
          name: 'Home',
          component: StartScreen
        },
        {
          path: 'lookup',
          component: Lookup,
          props: true,
          children: [
            {
              path: '',
              name: 'Lookup',
              component: PlatformViewer
            },
            {
              path: ':viewingPlatformKey',
              name: 'PlatformViewer',
              component: PlatformViewer
            }
          ]
        },
        {
          path: 'wizard',
          name: 'Wizard',
          component: Wizard
        },
        {
          path: 'wizard-summary',
          name: 'WizardSummary',
          component: WizardSummary
        },
        {
          path: 'compare',
          name: 'Compare',
          component: Compare
        },
        {
          path: 'final',
          name: 'Final',
          component: FinalSelection,
          props: true,
          children: [
            {
              path: '',
              name: 'FinalSelection',
              component: PlatformViewer
            }
          ]
        },
        {
          path: 'session',
          name: 'Session',
          component: Session,
          meta: { sessionSetter: true }
        }
      ]
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})

// check auth
router.beforeEach((to, from, next) => {
  const currentStatus = store.getters['shared/statuses']
  if (currentStatus.drawerOpen) {
    store.dispatch('shared/toggleDrawer')
  }
  if (currentStatus.compareDrawerOpen) {
    store.dispatch('shared/closeCompareDrawer')
  }

  firebase.auth().onAuthStateChanged(user => {
    const currentUser = firebase.auth().currentUser
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const isLoginPage = to.matched.some(record => record.meta.isLogin)

    // const fromSessionSetter = from.matched.some(record => record.meta.sessionSetter)
    // const toSessionSetter = to.matched.some(record => record.meta.sessionSetter)
    // const isSessionSet = store.getters['user/isSessionSet']
    // const isLoggedIn = store.getters['user/isLoggedIn']

    // if (currentUser) {
    //   store.dispatch('user/autoSignIn', currentUser)
    // }

    if (requiresAuth && !currentUser) {
      console.count('REDIRECT TO LOGIN: (Not logged in, path requires auth)')
      console.warn('PATH: ' + to.path)
      next({ name: 'Login' })
      return
    }

    if (isLoginPage && currentUser) {
      console.count('REDIRECT TO SESSION: (Logged in, to: /login')
      next({ name: 'Home' })
      return
    }

    // if (currentUser && !toSessionSetter && !isSessionSet) {
    //   console.count('REDIRECTED TO SESSION: (Logged in, to: !/session, session not set)')
    //   next({ name: 'Session' })
    //   return
    // }

    if (currentUser) {
      console.info('Current User Authenticated')
      store.dispatch('user/autoSignIn', currentUser)
      next()
      return
    }

    console.warn('Last next() call')
    console.count(to.path)
    next()
  })
})

router.afterEach((to, from) => {
  // scroll to top of header after each navigation
  // this is mainly for mobile, as the browser takes up
  // ui space and makes the app have to scroll up and down
  // since the page never refreshes
  const header = document.getElementById('unum-header')
  if (header) {
    header.scrollIntoView()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js